<span [innerHTML]="bannerAgreementFirstString"></span> {{ days }}
<span [innerHTML]="bannerAgreementSecondString"></span> {{ ' ' }}
<a [href]="link" target="_blank" rel="noopener noreferrer" [innerHTML]="bannerAgreementToString"></a>
{{ bannerAgreementToString }}
